import { useContext, useEffect, useState } from "react";
import { Button, Container, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaBoxOpen } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { FiltersProps } from "../../../../@types";
import { CardList } from "../../../../components/card-list";
import { PaginationList } from "../../../../components/pagination";
import { IMaterial } from "../../../../models/IMaterial";
import { listDiscipline } from "../../../../services/discipline.service";
import { removeFavorite } from "../../../../services/favorites.service";

import UsuarioContext from "../../../../../context/userContext/context";
import handleCardAgroup from "../../../../utils/handleCardAgroup/handleCardAgroup";
import { ListFilters } from "../../components/list-filters";
import { ListContent, NotFound } from "./styles";
import { useLocalStorage } from "react-use";

export const DisciplineList = (): JSX.Element => {
	const { t: translation } = useTranslation();
	const { user } = useContext(UsuarioContext);

	const [hashNews, setHashNews] = useState<IMaterial[][]>([]);
	const [totalItens, setTotalItens] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [loading, setLoading] = useState<boolean>(false);
	const [haveSheetFile, setHaveSheetFile] = useState<boolean>(false);
	const [sheetLink, setSheetLink] = useState<string>("");

	const [filters, setFilters] = useState<FiltersProps>({});
	const [localFilters, setLocalFilters] = useLocalStorage<FiltersProps>("filters", {});

	const queryParams = new URLSearchParams(window.location.search);
	const search = queryParams.get("search");

	let history = useHistory();

	useEffect(() => {
        if (localFilters && Object.keys(localFilters).length > 0) {
            setFilters(localFilters);
            clearFilters();
        }
    }, []);

    const clearFilters = () => {
		setFilters({});
        localStorage.removeItem("filters");
    };

	useEffect(() => {
		if (localFilters && Object.keys(localFilters).length == 0) {
			if (hashNews.length) {
				return;
			}
	
			if (search) {
				setLoading(true);
				return;
			}
	
			setLoading(true);
			listDiscipline().then((resp) => {
				setTotalItens(resp.count);
				setHashNews(handleCardAgroup(resp.results, 3));
				setHaveSheetFile(resp.spreadsheet !== "" ? true : false);
				setSheetLink(resp.spreadsheet);
			});
		}
	}, []);

	const handleDisciplineDetails = (event?: any) => {
		if (!event.tab) {
			history.push("/disciplines/" + event.material.id);
		} else {
			window.open("/disciplines/" + event.material.id);
		}
	};

	const handleFilters = (event?: any) => {
		setFilters({ ...event, page: 1 });
	};

	const handlePageChange = (page: number) => {
		if (localFilters && Object.keys(localFilters).length > 0) {
			const updatedLocalFilters = { ...localFilters, page };
			setLocalFilters(updatedLocalFilters);
			setFilters(updatedLocalFilters);
		} else {
			setFilters({ ...filters, page });
		}
		setCurrentPage(page);
	};


	const handleRemoveFavorite = (id: number) => {
		removeFavorite(id)
			.then(() => {
				toast.success("Disciplina removida com sucesso!", {
					position: "bottom-center",
				});
			})
			.catch((err: any) => {
				toast.error("Ocorreu um erro ao remover esta disciplina.");
			});
	};

	useEffect(() => {

		let queryFilter = localFilters && localStorage.getItem("filters") !== "{}" ? localFilters : filters;
		
		if (
			Object.keys(queryFilter).length > 0 &&
			(queryFilter.q !== "" ||
				queryFilter.page ||
				(queryFilter.knowledge && queryFilter.knowledge.length !== 0) ||
				(queryFilter.modalities && queryFilter.modalities.length !== 0) ||
				(queryFilter.categories && queryFilter.categories !== ""))
		) {
			setLoading(true);
			listDiscipline(queryFilter)
				.then((resp) => {
					setTotalItens(resp.count);
					setHashNews(handleCardAgroup(resp.results, 3));
					if (filters && filters.page) {
						setCurrentPage(filters.page);
					}
					setLoading(false);
				})
				.catch(() => {
					setLoading(false);
				});
		}
	}, [filters, localFilters]);

	return (
		<Container fluid>
			<Row className="mb-2">
				<ListFilters
					hasModalityFilter
					handleFilter={handleFilters}
				></ListFilters>
			</Row>
			<Row className="text-darker-grey">
				<span>
					<b>{totalItens}</b> {translation("filters.resultFound")}
				</span>
				{haveSheetFile && user.profile_status !== "Parceiro" && (
					<div className="d-flex align-items-center mt-3">
						<p className="mb-0 mr-2">
							Não encontrou o que procura? Veja as disciplinas que
							estarão disponíveis em breve
						</p>
						<Button
							onClick={() => window.open(sheetLink, "_blank")}
						>
							Conferir Lista
						</Button>
					</div>
				)}
			</Row>
			<Row className="mt-4 mb-3">
				{loading ? (
					<NotFound>
						<Spinner
							animation="border"
							variant="primary"
							style={{
								width: "2rem",
								height: "2rem",
								borderWidth: "0.25em",
								borderRightColor: "transparent",
							}}
						/>
					</NotFound>
				) : (
					<>
						{hashNews.length === 0 ? (
							<NotFound>
								<FaBoxOpen className="iconNotFound"></FaBoxOpen>
								<div>Nenhum resultado encontrado</div>
							</NotFound>
						) : (
							<ListContent>
								{!!hashNews.length &&
									hashNews.map(
										(arrayMaterial: IMaterial[], index) => {
											return (
												<div key={index}>
													{arrayMaterial.map(
														(material) => (
															<CardList
																key={material.id}
																material={
																	material
																}
																onDetails={
																	handleDisciplineDetails
																}
																removeFavorite={
																	handleRemoveFavorite
																}
															/>
														)
													)}
												</div>
											);
										}
									)}
							</ListContent>
						)}
					</>
				)}
			</Row>
			<Row>
				{!loading && hashNews.length > 0 ? (
					<PaginationList
						currentPage={currentPage}
						totalItems={totalItens}
						onPageChange={handlePageChange}
					></PaginationList>
				) : (
					<></>
				)}
			</Row>
		</Container>
	);
};
